import { render, staticRenderFns } from "./SourceItem.vue?vue&type=template&id=a3f65700&scoped=true&"
import script from "./SourceItem.vue?vue&type=script&lang=js&"
export * from "./SourceItem.vue?vue&type=script&lang=js&"
import style0 from "./SourceItem.vue?vue&type=style&index=0&id=a3f65700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f65700",
  null
  
)

export default component.exports